import React, {useEffect, useRef, useState} from 'react';
import {Badge, Col, Form, message, Row, Spin, Tabs} from 'antd';
import ProForm, {ProFormInstance} from '@ant-design/pro-form';
import {FileUploadUtility, WdiFileList} from '@/components/WdiControls/WdiFileUpload';
import TabPane from '@ant-design/pro-card/lib/components/TabPane';
import {FormPageProps, WdiFormPageTitle} from '@/components/WdiBus/FormPage';
import {approvalConfig, fgMoreConfig, initApprovalPageContext, ViewEntityProps} from '../components/data';
import {ResponseStatus} from '@/utils/request';
import DataStore from '@/components/GridWidget/DataStore';
import {DataOptions} from '@/services/basic/metadata';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {WdiCardTitle, WdiInput, WdiStaffCard} from '@/components/WdiControls';
import {Enum} from '@/enums/system';
import FormSaInfosApp from '@/pages/sales/sa/components/FormSaInfos';
import FormSsInfosApp from '@/pages/sales/ss/components/FormSsInfos';
import DynamicInformation from '../components/DynamicInformation';
import {FormGoods, FormSp} from '@/services/sales/sp';
import {FreeGoodsPaymentDetailsForApprovalPanel} from "@/pages/sales/sp/components/detail";
import {SPWarningApprovalApp} from "@/pages/sales/sp/components/WarningInformation";
import {FormGoodsForApprovalPanel} from "@/pages/sales/sp/FreeGoodsPaymentApply/components/FormGoods";
import {WdiEditor} from "@/components/WdiControls/WdiEditor";

const FreeGoodsPaymentApprovalApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [entity, setEntity] = useState<ViewEntityProps>();
  const [formGoodsDataSource, setFormGoodsDataSource] = useState<any[]>([]);
  const [warningCount, setWarningCount] = useState<number>(0);
  const [activeKey, setActiveKey] = useState<string>("1");
  useEffect(() => {
    if (!formRef?.current) {
      return;
    }
    setActiveKey(props.data?.defaultActiveKey ?? "1");
  }, [!!(formRef?.current)])


  const onGoodsChange = (data: any) => {
    setFormGoodsDataSource(data);
  };

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initApprovalPageContext(params);
        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity: ViewEntityProps = result.data;

        setEntity(viewEntity);

        if (viewEntity.formSp) {
          formRef.current?.setFieldsValue({
            amountInVat: viewEntity.formSp.amountInVat,
            remark: viewEntity.formSp.remark,
            fileInfo: FileUploadUtility.parse(viewEntity.formSp.fileName, viewEntity.formSp.filePath)
          });
          FormGoods.getForApply(viewEntity.formSp.formSpId || 0).then(responseResult => {
            if (responseResult.data && responseResult.data.length > 0) {
              setFormGoodsDataSource(DataStore.init(responseResult.data));
            }
          })
          FormSp.Buttons.countOfWarning(viewEntity?.formSp?.formSpId || 0).then(response => {
            setWarningCount(response.data);
          });
        }

        if (viewEntity.paymentMethodId) {
          DataOptions.search({typeGroup: 5, inValues: String(viewEntity.paymentMethodId)}).then(responseResult => {
            formRef.current?.setFieldsValue({
              paymentMethodId: responseResult.data[0].name
            });
          })
        }

        if (viewEntity.formSpDetails) {
          setDataSource(DataStore.init(viewEntity.formSpDetails));
        }
      }
    })();
  }, [props.data]);

  useEffect(() => {
    if (props.setPageTitle && entity) {
      let title = `活动核销单【${entity.form?.formNo}】`;
      DataOptions.search({typeGroup: 3, value: entity.form?.statusId}).then(response => {
        if (response.code !== ResponseStatus.SUCCESS) {
          message.error(response.message);
          return;
        }
        if (response.data && response.data.length > 0) {
          if (entity.form?.statusId != Enum.FormStatus.SCRAP && entity.form?.exportStatus == Enum.ExportStatus.EXPORT_SUCCESS) {
            title += `，已导出`;
          } else {
            title += `，${response.data[0].name}`;
          }
          if (props.setPageTitle) props.setPageTitle(
            <WdiFormPageTitle
              title={title}
              onClose={props.onClose}
              callback={props.callback}
              form={entity?.form}
              useCaseId={Enum.UseCase.SP}
              moreConfig={fgMoreConfig}
              approvalConfig={approvalConfig}/>
          );
        }
      });
    }
  }, [props.setPageTitle, entity]);

  return (
    <>
      <WdiStaffCard formId={entity?.form?.formId}/>
      <Tabs activeKey={activeKey} onTabClick={(key, _) => setActiveKey(key)} size="large">
        <TabPane tab={<span>核销信息</span>} key="1">
          <ProForm
            formRef={formRef}
            submitter={{
              render: () => {
                return (<></>)
              },
            }}
          >
            <FormSaInfosApp formRef={formRef} defaultCollapsed={true} formSaId={entity?.formSaId}/>
            {entity?.formSsId &&
              <FormSsInfosApp formRef={formRef} defaultCollapsed={true} formSsId={entity?.formSsId}/>}
            <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.FORM_SP} title='活动核销单信息'/>}
                      collapsed={true}>
              <Row gutter={[16, 0]}>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="amountInVat" label="本次核销含税总金额">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="paymentMethodId" label="支付方式">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={16}>
                  <Form.Item name="remark" label="核销备注">
                    <WdiEditor readOnly={true}/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                  <Form.Item
                    name="fileInfo"
                    label="核销附件"
                    valuePropName='fileList'
                    getValueFromEvent={(e: any) => {
                      return e.fileList || [];
                    }}
                  >
                    <WdiFileList/>
                  </Form.Item>
                </Col>
              </Row>
            </WdiPanel>
          </ProForm>
          <FreeGoodsPaymentDetailsForApprovalPanel
            data={{
              ecFieldConfigs: entity?.ecFieldConfigs,
              allowViewSfa: entity?.allowViewSfa,
              formSp: entity?.formSp,
              form: entity?.form,
            }}
            dataSource={dataSource}
            onChange={(data: any) => {
              setDataSource(DataStore.init(data));
            }}
          />
          <FormGoodsForApprovalPanel
            pid={props.data?.formId}
            dataSource={formGoodsDataSource}
            onChange={onGoodsChange}
          />
        </TabPane>
        <TabPane
          tab={
            <>
              <span>警示信息</span>
              <Badge count={warningCount}
                     style={{
                       color: "black",
                       boxShadow: "none",
                       background: "none",
                       top: "-20px",
                       right: "-15px",
                       position: 'absolute'
                     }}>
              </Badge>
            </>
          }
          key="3"
        >
          <SPWarningApprovalApp formId={entity?.form?.formId}/>
        </TabPane>
        <TabPane tab={<span>动态信息</span>} key="4">
          {
            entity?.form ? <DynamicInformation
              formId={entity?.form?.formId}
              formTypeId={entity?.form?.formTypeId}
              pageTypeId={entity?.form?.pageTypeId}
              useCaseId={Enum.UseCase.SP}
            /> : <Spin/>
          }
        </TabPane>
      </Tabs>
    </>
  );
};
export default FreeGoodsPaymentApprovalApp;
